// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bairun-dialog-ticket-add .dialog-footer {\n  left: 0 !important;\n  right: 0 !important;\n  text-align: center !important;\n}\n.capital-form-item .el-form-item__label {\n  width: 100% !important;\n  text-align: left;\n}\n.capital-form-item .el-form-item__content {\n  margin-left: 0 !important;\n  margin-right: 15px !important;\n}", ""]);
// Exports
module.exports = exports;
